export default __webpack_public_path__ + "static/media/t2-p1-img1.be2bc5f8.png";